export enum ComponentIdEnum {
  BASIC_COMPONENT = 'Basic-Component', // 基本容器
  SINGLE_SUPER_TAB_COMPONENT = 'single-super-tab-component', // 单Tab切换新版
  TEXT_YELLOW_TITLE_COMPONENT = 'text-yellow-title-component', // 黄色标题文本
  BOBY_COMPONENT = 'body-component', // 主页面容器
  CENTER_UP_AND_DOWN_COMPONENT = 'center-up-and-down-component', // 上下居中容器
  FEATURE_COMPONENT = 'feature-component', // 卖点组件
  IMG_COMPONENT = 'img-component', // 图 片_1
  COLUMNS_CONTAINER_COMPONENT = 'columns-container-component', // 多列容器
  ROWS_CONTAINER_COMPONENT = 'rows-container-component', // 多行容器
  PDF_BUTTON_COMPONENT = 'pdf-button-component', // PDF按钮容器
  TABLE_COMPONENT = 'table-component', // PDF按钮容器
  TEXT_CONTENT_COMPONENT = 'text-content-component', // 内容文本
  TEXT_TITLE_COMPONENT = 'text-title-component', // 标题文本
  VIDEO_COMPONENT = 'video-component', // 视频容器
  MULTI_SUPER_TAB_COMPONENT = 'multi-super-tab-component', // 多Tab切换新版
  RICH_TEXT_COMPONENT = 'rich-text-component', // 富文本组件
  IMG_LINK_COMPONENT = 'img-link-component', // 图片链接组件
  HORSE_LIGHT_COMPONENT = 'horse-light-component', // 走马灯组件
  VIDEO_V2_COMPONENT = 'video-v2-component', // 视频组件v2
  INS_CARD_COMPONENT = 'ins-card-component', // ins社媒卡片组件
}
